import { onNetworkDegraded, onNetworkRecovered } from '@/services/network/network_events'

// Жизненный цикл глобального тоста сетевой деградации (§4.12, issue #275).
//
// Проблема прежней версии: тост показывался с дефолтным sonner-таймаутом (~4 с)
// и троттлился раз в 10 с. При затяжном дропе, когда юзер тыкает запросы реже
// раза в 10 с, тост успевал исчезнуть — и юзер снова «работал в пустоту».
//
// Решение: тост залипший (duration: Infinity по фиксированному id) и снимается
// только при восстановлении связи — первый успешный ответ (emitNetworkRecovered)
// или браузерное событие `online`. Пока деградация держится, тост висит, сколько
// бы запросов ни падало. Троттл больше не нужен: фиксированный id схлопывает
// дубли, повторный degraded при уже висящем тосте — no-op.

export const NETWORK_DEGRADED_TOAST_ID = 'network-degraded'

interface NetworkToastDeps {
  // Резолвится лениво (на показе, не на setup) — локаль может переключиться.
  show: () => void
  dismiss: () => void
  onOnline: (handler: () => void) => void
}

export function setupNetworkToast(deps: NetworkToastDeps): void {
  let shown = false

  function showToast(): void {
    if (shown) return
    shown = true
    deps.show()
  }

  function dismissToast(): void {
    if (!shown) return
    shown = false
    deps.dismiss()
  }

  onNetworkDegraded(showToast)
  onNetworkRecovered(dismissToast)
  deps.onOnline(dismissToast)
}
